<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconNotauthenticated_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.88 22.413q2.413 3.32 6.12 4.254 3.707-.934 6.12-4.254t2.413-7.373V8.533L16 5.333l-8.533 3.2v6.507q0 4.053 2.413 7.373m6.12-1.08a1.067 1.067 0 0 0 0-2.133h-.01a1.067 1.067 0 0 0 0 2.133zM14.933 16a1.067 1.067 0 0 0 2.134 0v-4.267a1.067 1.067 0 0 0-2.134 0z"
        clip-rule="evenodd"
    />
</svg>
